import { useState } from "react"
import ILineItem from "~/interfaces/ILineItem"

export const useStoreContent = () => {
  const [lineItems, setLineItems] = useState<ILineItem[]>([])
  
  const handleRemoveItem = (id: string | null): void => {
    if (!id) return

    setLineItems((prev) => {
      
      const updatedItems = [...prev]

      const index = updatedItems.findIndex((item) => item.add_on_id === id)

      if (index > -1) {
        updatedItems.splice(index, 1)
      }

      return updatedItems
    })
  }

  return {
    lineItems,
    setLineItems,
    handleRemoveItem,
  }
}
